import React, { Component } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import notificationService from "../../../NotificationModule/General/NotificationService";
import RecipientModal from "../../../NotificationModule/General/RecipientModal";
import { connect } from "react-redux";
import actions from "../../../../store/notificatiommodule/action";
import AuthService from "../../../Auth/AuthService";
import PermissionFeature from "../../../Permissions/PermissionFeature";
class MemberTriggersTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      triggers: [],
      loading: false,
      search: "",
      showModal: false,
      selectedTrigger: null,
      selectedTriggerRecipients: [],
    };
  }

  componentDidMount() {
    if (this.props.memberId) {
      this.loadTriggers();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.shouldReload && !prevProps.shouldReload) {
      this.props.fetchNotifications(false);
      this.loadTriggers();
    }
  }

  loadTriggers = async () => {
    this.setState({ loading: true });
    try {
      const data = await notificationService.GetTriggersByMemberId(
        this.props.memberId
      );
      if (data != null) {
        // Group recipients by trigger
        const groupedTriggers = this.groupRecipientsByTrigger(data);
        this.setState({ triggers: groupedTriggers });
      }
    } catch (error) {
      console.error("Error loading triggers:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  groupRecipientsByTrigger = (data) => {
    const triggerMap = new Map();

    data.forEach((item) => {
      if (!triggerMap.has(item.triggerId)) {
        triggerMap.set(item.triggerId, {
          id: item.triggerId,
          triggerKey: item.triggerKey,
          moduleId: item.moduleId,
          moduleName: item.moduleName,
          recipients: [],
        });
      }

      if (item.recipientId) {
        triggerMap.get(item.triggerId).recipients.push({
          id: item.recipientId,
          recipientId: item.recipient_tplpId,
          recipientName: item.recipientName,
          recipientType: item.recipientType,
          recipientTypeId: item.recipientTypeId,
        });
      }
    });

    return Array.from(triggerMap.values());
  };

  openModal = (trigger) => {
    this.setState({
      showModal: true,
      selectedTrigger: {
        id: trigger.id,
        trigger_Key: trigger.triggerKey,
        module_Name: trigger.moduleName,
      },
      selectedTriggerRecipients: trigger.recipients.map((r) => ({
        id: r.id,
        recipient_Id: r.recipientId,
        recipient_Type_Id: r.recipientTypeId,
        recipient_Type: r.recipientType, // this.getRecipientTypeName(r.recipientTypeId),
        recipient_Name: r.recipientName,
      })),
    });
  };

  getRecipientTypeName = (typeId) => {
    switch (typeId) {
      case 1:
        return "Team";
      case 2:
        return "Position";
      case 3:
        return "Linked Position";
      default:
        return "Unknown";
    }
  };

  handleSaveRecipients = async (recipients) => {
    const { selectedTrigger } = this.state;

    try {
      const saveData = {
        TriggerID: selectedTrigger.id,
        Recipients: recipients.map((r) => ({
          Id: r.recipient_Id,
          RecipientType: r.recipient_Type_Id,
        })),
      };

      await notificationService.SaveTriggerRecipients(saveData);
      await this.loadTriggers(); // Reload after save
      this.setState({ showModal: false });
    } catch (error) {
      console.error("Error saving recipients:", error);
      alert("Failed to save recipients. Please try again.");
    }
  };

  formatRecipients = (recipients) => {
    if (!recipients || recipients.length === 0) {
      return <span className="text-muted">-</span>;
    }

    return recipients.map((r, index) => {
      let badgeClass = "badge-secondary";
      let typeName = "";

      if (r.recipientTypeId === 1) {
        typeName = "Team";
        badgeClass = "badge-primary";
      } else if (r.recipientTypeId === 2) {
        typeName = "Position";
        badgeClass = "badge-info";
      } else if (r.recipientTypeId === 3) {
        typeName = "Linked";
        badgeClass = "badge-warning";
      }

      return (
        <div key={index} className="mb-1">
          <span className={`badge ${badgeClass} mr-1`}>{typeName}</span>
          <span className="small">{r.recipientName}</span>
        </div>
      );
    });
  };

  getFilteredTriggers = () => {
    const { triggers, search } = this.state;
    if (!search) return triggers;

    const searchLower = search.toLowerCase();
    return triggers.filter((trigger) => {
      const triggerKey = trigger.triggerKey
        ? trigger.triggerKey.toLowerCase()
        : "";
      const moduleName = trigger.moduleName
        ? trigger.moduleName.toLowerCase()
        : "";

      if (triggerKey.includes(searchLower)) return true;
      if (moduleName.includes(searchLower)) return true;

      // Check recipients
      if (trigger.recipients && trigger.recipients.length > 0) {
        return trigger.recipients.some((r) => {
          const recipientName = r.recipientName
            ? r.recipientName.toLowerCase()
            : "";
          return recipientName.includes(searchLower);
        });
      }

      return false;
    });
  };

  columns = () => {
    return [
      {
        dataField: "triggerKey",
        text: "Trigger Key",
        sort: true,
        headerStyle: { width: "30%" },
        classes: "align-middle",
      },
      {
        dataField: "moduleName",
        text: "Module",
        headerStyle: { width: "20%" },
        classes: "align-middle",
        formatter: (cell) => {
          return <span className="badge badge-secondary">{cell || "N/A"}</span>;
        },
      },
      {
        dataField: "recipients",
        text: "Recipients",
        headerStyle: { width: "35%" },
        classes: "align-middle",
        formatter: (cell) => this.formatRecipients(cell),
      },
      {
        dataField: "action",
        text: "Action",
        headerStyle: { width: "15%", textAlign: "center" },
        hidden:
          !AuthService.canAdd(PermissionFeature.NotificationRecipient) &&
          !AuthService.canDelete(PermissionFeature.NotificationRecipient),
        classes: "align-middle text-center",
        formatter: (cell, row) => (
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => this.openModal(row)}
            title="Manage Recipients"
          >
            <i className="fas fa-cog"></i>
          </button>
        ),
        align: "center",
      },
    ];
  };

  handleSearchChange = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const {
      loading,
      search,
      showModal,
      selectedTrigger,
      selectedTriggerRecipients,
    } = this.state;
    const filteredTriggers = this.getFilteredTriggers();

    return (
      <>
        <div className="mt-3">
          <div className="row mb-3">
            <div className="col-md-6">
              <h6 className="mt-2">Notification Triggers</h6>
            </div>
            <div className="col-md-6">
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search triggers..."
                value={search}
                onChange={this.handleSearchChange}
              />
            </div>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <p className="mt-2 text-muted">Loading triggers...</p>
            </div>
          ) : (
            <BootstrapTable
              keyField="recipientsId"
              data={filteredTriggers}
              columns={this.columns()}
              pagination={paginationFactory({
                sizePerPage: 10,
                sizePerPageList: [5, 10, 25, 50],
                showTotal: true,
              })}
              bootstrap4
              striped
              hover
              condensed
              bordered={false}
            />
          )}
        </div>

        <RecipientModal
          show={showModal}
          onHide={() => this.setState({ showModal: false })}
          trigger={selectedTrigger}
          recipients={selectedTriggerRecipients}
          onSave={this.handleSaveRecipients}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  shouldReload: state.notificationModule.shouldReload, // Direct access since your reducer exports state directly
});

export default connect(mapStateToProps, {
  fetchNotifications: actions.fetchNotifications,
})(MemberTriggersTable);
